import { useSimpleReadPattern } from 'apps/sigma2-ui/src/lib/hooks/useSimpleReadPattern';
import { useMemo } from 'react';
import { getApiBaseUrl } from 'apps/sigma2-ui/src/constants/environment';
import React from 'react';
import { DatabaseSchedulesForReadWithOrgAndDbInfo } from 'libs/end-to-end/src/types/databases/scheduling/database-schedule';
import { Table } from 'apps/sigma2-ui/src/components/ui/Table';
import { AdminLayout } from 'apps/sigma2-ui/src/components/AdminLayout';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { getDateTimeAsReadableString } from 'libs/end-to-end/src/dates';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { AdminBreadcrumbs } from 'apps/sigma2-ui/src/components/ui/AdminBreadcrumbs';

export const DatabaseSchedulesAllPage = () => {
  const language = useLanguage();

  const readSchedulesPattern = useSimpleReadPattern(
    useMemo(() => {
      return {
        getUrlFn: () => `${getApiBaseUrl()}/schedules`,
        canRead: true,
        responseSchema: DatabaseSchedulesForReadWithOrgAndDbInfo,
      };
    }, []),
  );

  const itemsToShow = useMemo(() => {
    if (readSchedulesPattern.status === 'done') {
      return readSchedulesPattern.entity.schedules;
    } else {
      return [];
    }
  }, [readSchedulesPattern]);

  const isLoading = useMemo(() => {
    return readSchedulesPattern.status === 'loading';
  }, [readSchedulesPattern]);

  return (
    <AdminLayout currentPage={'DatabaseSchedulesAllPage'}>
      <AdminBreadcrumbs
        items={[
          { label: 'Home', to: '/admin' },
          { label: 'Database Schedules', to: '/schedules' },
        ]}
      />
      <Spacing size={'lg'} direction={'vertical'}>
        <S2Typography
          variant={'headline-4'}
          translatedContent={language.dangerousUserInput({
            value: 'Database Schedules',
          })}
        />

        <Table
          columnDefinitions={[
            {
              id: 'name',
              header: () => 'Name',
              cell: ({ item }) => {
                return <>{item.name}</>;
              },
            },
            {
              id: 'organizationId',
              header: () => 'Organization',
              cell: ({ item }) => {
                return <>{item.organization?.name}</>;
              },
            },
            {
              id: 'databaseId',
              header: () => 'Database',
              cell: ({ item }) => {
                return <>{item.database?.name}</>;
              },
            },
            {
              id: 'id',
              header: () => 'ID',
              cell: ({ item }) => {
                return <>{item.scheduleId}</>;
              },
            },
            {
              id: 'status',
              header: () => 'Status',
              cell: ({ item }) => {
                return <>{item.status}</>;
              },
            },
            {
              id: 'schedule',
              header: () => 'Schedule',
              cell: ({ item }) => {
                return <>{item.scheduleConfigurationType}</>;
              },
            },
            {
              id: 'nextScheduledRun',
              header: () => 'Next Run',
              cell: ({ item }) => {
                return (
                  <>
                    {item.details.nextScheduledEpoch
                      ? getDateTimeAsReadableString(
                          new Date(item.details.nextScheduledEpoch),
                        )
                      : 'N/A'}
                  </>
                );
              },
            },
            {
              id: 'edit',
              header: () => 'Edit',
              cell: ({ item }) => {
                return (
                  <Button
                    behavior={{
                      type: 'href',
                      href: `/organizations/${item.organizationId}/databases/${item.databaseId}/schedule/${item.scheduleId}`,
                    }}
                    variant={'outline'}
                    size={'small'}
                  >
                    Edit
                  </Button>
                );
              },
            },
          ]}
          items={itemsToShow}
          isLoading={isLoading}
        />
      </Spacing>
    </AdminLayout>
  );
};
